import React, { Component } from 'react';
import ClientFormView from './ClientFormView';
import queryString from 'query-string';
import { url } from '../../../Server/url/GlobalUrl';
import axios from 'axios';

class ClientFormComponent extends Component {
  state = {
    legal_entity: '',
    company_number: '',
    company_name: '',
    trading_address: '',
    address_line_1: '',
    address_line_2: '',
    address_line_3: '',
    longitude: '',
    latitude: '',
    communication_address: '',
    phone: '',
    fax: '',
    email: '',
    authResponse: '',
    city: '',
    country: '',
    county: '',
    success: false,
    data: '',
    edit_button: false,
    registered_office: '',
    modal_show: false,
    edit_button: false,
    redirection: false,
    postal_code: '',
    addresses: [],
  };
  hideCustomModal = () => {
    this.setState({ modal_show: false });
    if (this.state.redirection) {
      window.location.replace('/client/summary');
    }
  };

  showCustomModal = () => {
    this.setState({ modal_show: true });
  };
  getDataPostCode = () => {
    var data = this.state.postal_code.replaceAll(' ', '');
    this.setState({ addresses: [] });
    this.setState({ addresses: '' });
    if (data.length > 5) {
      console.log('DSD');
      fetch(
        'https://api.getaddress.io/find/' +
          data +
          '?api-key=O-vbZ8Cu4EqwX9XPa_ERLw29608',
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
        .then((res) => {
          if (res.status == 400) {
            this.showCustomModal();
            this.setState({
              authResponse: 'Please enter the valid UK postcode',
            });
            this.setState({ postcode: '' });
          }

          return res.json();
        })
        .then(
          (result) => {
            console.log(
              'postcode',
              typeof result,
              result,
              Object.keys(result).length
            );
            if (Object.keys(result).length > 1) {
              this.setState({ addresses: result.addresses });

              //     console.log(this.state.address)
              // }else{
              //     this.setState({address:""})
            }
          },
          (error) => {
            console.log('error', error);
          }
        );
    }
  };

  fetch_company_details = () => {
    console.log('DDS');
    let key = 'ORiKIb8SRM_PCUX4WXyk5aHsqYOMs24AwkCvIHmq';
    var data = this.state.company_number;
    fetch(
      'http://63.35.252.151:8080/https://api.companieshouse.gov.uk/company/' +
        data +
        '/',
      {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: key,
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        console.log('response___________________', response);
        const name = response.company_name;
        const address_line_2 = response.registered_office_address.address_line_2
          ? response.registered_office_address.address_line_2 + ', '
          : '';
        const address_line_1 = response.registered_office_address.address_line_1
          ? response.registered_office_address.address_line_1 + ', '
          : '';
        const country = response.registered_office_address.country
          ? response.registered_office_address.country + ', '
          : '';
        const locality = response.registered_office_address.locality
          ? response.registered_office_address.locality + ', '
          : '';
        const postal_code = response.registered_office_address.postal_code
          ? response.registered_office_address.postal_code
          : '';
        this.setState({
          registered_office:
            address_line_1 + address_line_2 + country + locality + postal_code,
        });
        console.log('company type______________', response.type);
        this.setState({ company_name: name });
        if (response.type === 'ltd') {
          this.setState({ legal_entity: 'PL' });
        } else if (response.type === 'llp') {
          this.setState({ legal_entity: 'LLP' });
        } else if (response.type === 'limited-partnership') {
          this.setState({ legal_entity: 'PT' });
        }
      })
      .catch((error) => {
        console.log('error__________', error);
        this.setState({ authResponse: 'Please enter correct company number' });
        this.showCustomModal();
      });
  };

  handelData = (identity, data) => {
    console.log('identity', identity);
    console.log('data', data);
    if (identity === 'legal_entity') {
      this.setState({ legal_entity: data });
    } else if (identity === 'company_number') {
      this.setState({ company_number: data });
    } else if (identity === 'postal_code') {
      this.setState({ postal_code: data });
    } else if (identity == 'company_name') {
      this.setState({ company_name: data });
    } else if (identity === 'trading_address') {
      this.setState({ trading_address: data });

      var postcode = this.state.postal_code;
      fetch(
        'https://api.getaddress.io/find/' +
          postcode +
          '/' +
          data +
          '?api-key=O-vbZ8Cu4EqwX9XPa_ERLw29608&expand=true',
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
        .then((res) => {
          if (res.status == 400) {
            console.log('Not found');
          } else if (res.status == 200 || res.status == 201) {
            return res.json();
          }
        })
        .then(
          (result) => {
            console.log(result, 'RESULT');
            if (result) {
              console.log('result-country', result['addresses'][0]['country']);
              console.log('result-line_1', result['addresses'][0]['line_1']);
              console.log('result-line_2', result['addresses'][0]['line_2']);
              console.log(
                'result-town_or_city',
                result['addresses'][0]['town_or_city']
              );
              console.log('result-county', result['addresses'][0]['county']);
              console.log(
                'result-district',
                result['addresses'][0]['district']
              );
              this.setState({
                city:
                  result['addresses'][0]['district'] +
                  ',' +
                  result['addresses'][0]['town_or_city'],
              });
              this.setState({ country: result['addresses'][0]['country'] });
              this.setState({ county: result['addresses'][0]['county'] });

              this.setState({
                address_line_1: result['addresses'][0]['line_1'],
              });
              this.setState({
                address_line_2: result['addresses'][0]['line_2'],
              });
              this.setState({
                address_line_3: result['addresses'][0]['line_3'],
              });
              this.setState({ latitude: result.latitude });
              this.setState({ longitude: result.longitude });

              console.log('this.state.country', this.state.country);
              console.log('this.state.city', this.state.city);
              console.log('this.state.county', this.state.county);
            }
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else if (identity === 'communication_address') {
      this.setState({ communication_address: data });
    } else if (identity === 'phone') {
      this.setState({ phone: data });
    } else if (identity === 'fax') {
      this.setState({ fax: data });
    } else if (identity === 'email') {
      this.setState({ email: data });
    } else if (identity === 'registered_office') {
      this.setState({ registered_office: data });
    }
  };

  componentDidMount() {
    const uri = window.location.href.split('/').pop();
    if (uri === '#edit') {
      let id = localStorage.getItem('cv-id');
      console.log('cv-id', id);
      fetch(url + '/api/v1/user/company-detail/' + id + '/', {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.json())
        .then((result) => {
          console.log('result_______', result);
          this.setState({
            trading_address: result.trading_address,
            company_name: result.company_name,
            company_number: result.company_number,
            legal_entity: result.entity,
            registered_office: result.office_address,
            trading_address: result.trading_address,
            phone: result.phone_number,
            communication_address: result.communication_address,
            email: result.email,
            fax: result.Fax_number,
            edit_button: true,
          });
        });
    }
  }
  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  handelSubmit = () => {
    if (
      this.state.company_number === '' ||
      !this.validateEmail(this.state.email) ||
      this.state.legal_entity === '' ||
      this.state.registered_office === '' ||
      this.state.trading_address === '' ||
      this.state.communication_address === '' ||
      this.state.phone === '' ||
      this.state.phone.length > 10 ||
      this.state.email === ''
    ) {
      if (this.state.legal_entity === '') {
        this.showCustomModal();
        this.setState({ authResponse: 'Please Fill Legal Entity' });
      } else if (this.state.company_number === '') {
        this.showCustomModal();
        this.setState({ authResponse: 'Please Fill Company Number' });
      } else if (this.state.registered_office === '') {
        this.showCustomModal();
        this.setState({ authResponse: 'Please Fill Registered office' });
      } else if (this.state.trading_address === '') {
        this.showCustomModal();
        this.setState({ authResponse: 'Please Fill Trading Address' });
      } else if (this.state.communication_address === '') {
        this.showCustomModal();
        this.setState({ authResponse: 'Please Fill Communication Address' });
      } else if (this.state.phone === '' || this.state.phone.length > 10) {
        this.showCustomModal();
        this.setState({ authResponse: 'Please Enter Valid Phone Number' });
      } else if (
        this.state.email === '' ||
        !this.validateEmail(this.state.email)
      ) {
        this.showCustomModal();
        this.setState({ authResponse: 'Please Fill Correct Email Address' });
      } else if (this.state.postal_code === '') {
        this.showCustomModal();
        this.setState({ authResponse: 'Please Fill Postal Code' });
      }
    } else {
      var id = localStorage.getItem('cv-id');
      var data = {
        user: id,
        company_number: this.state.company_number,
        company_name: this.state.company_name,
        city: this.state.city,
        country: this.state.country,
        county: this.state.county,
        address_line_1: this.state.address_line_1,
        address_line_2: this.state.address_line_2,
        address_line_3: this.state.address_line_3,
        longitude: this.state.longitude,
        latitude: this.state.latitude,
        entity: this.state.legal_entity,
        office_address: this.state.registered_office,
        trading_address: this.state.trading_address,
        communication_address: this.state.communication_address,
        phone_number: this.state.phone,
        Fax_number: this.state.fax,
        email: this.state.email,
      };
      if (this.state.edit_button) {
        fetch(url + '/api/v1/user/company-detail/' + id + '/', {
          method: 'PUT',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            console.log('response', response);
            if (response['status'] === 201 || response['status'] === 200) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Contact details Edited Successfuly',
              });
              this.setState({ redirection: true });
              return response.json();
            } else if (response['status'] === 400) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Some Thing Went Wrong Please try again',
              });
            }
          })
          .then((result) => {
            console.log('result', result);
          });
      } else {
        console.log('-------submitted--------');
        console.log(this.state);
        fetch(url + '/api/v1/user/company-detail/', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            console.log('response', response);
            if (response['status'] === 201 || response['status'] === 200) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Contact details Submitted Successfuly',
              });
              this.setState({ redirection: true });
              return response.json();
            } else if (response['status'] === 400) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Some Thing Went Wrong Please try again',
              });
            }
          })
          .then((result) => {
            console.log('result', result);
          });
      }
    }
  };

  render() {
    return (
      <ClientFormView
        handelData={this.handelData}
        company_number={this.state.company_number}
        fetch_company_details={this.fetch_company_details}
        company_name={this.state.company_name}
        trading_address={this.state.trading_address}
        legal_entity={this.state.legal_entity}
        phone={this.state.phone}
        getDataPostCode={this.getDataPostCode}
        fax={this.state.fax}
        email={this.state.email}
        registered_office={this.state.registered_office}
        handelSubmit={this.handelSubmit}
        authResponse={this.state.authResponse}
        modal_show={this.state.modal_show}
        hideCustomModal={this.hideCustomModal}
        communication_address={this.state.communication_address}
        edit_button={this.state.edit_button}
        postal_code={this.state.postal_code}
        addresses={this.state.addresses}
      />
    );
  }
}

export default ClientFormComponent;
